export const openPositions = [{}];
